<template>
  <div class="popupViewProfileCardImage">
    <figure class="networkSearchItemImage">
      <div
        class="img"
        :style="
          `background-image: url('${getAvatarLink(
            data.avatar,
            getDefaultAvatar(data.roleName),
          )}')`
        "
      />
    </figure>
    <div class="popupViewProfileCardImageText">
      <h3
        style="color: #502423; font-size: 17px; font-weight: 400; margin-bottom: 4px;"
      >
        {{ data.company }}
      </h3>
      <h3
        class="popupViewProfileCardImageTitle"
        style="color: #502423; font-size: 3rem; display: flex; align-items: center; flex-wrap: wrap;"
      >
        {{ data.name }}
        <div
          v-if="data.classification"
          class="chip-user"
          :style="`background-color:${chipColor(data.classification)}}`"
        >
          {{ chipText(data.classification) }}
        </div>
      </h3>
      <h5 class="popupViewProfileCardImageDesc">
        {{ data.phoneNumber }}
      </h5>
      <h5 class="popupViewProfileCardImageEmail">
        {{ data.email }}
      </h5>
      <!-- v-if="data.homepage" -->
      <MainButton
        v-if="data.homepage && !hideHomepage"
        :href="data.homepage"
        btnText="홈페이지"
      />
    </div>
  </div>
</template>

<script>
import matchingColorMixins from "@/mixins/matching-color-mixins";

export default {
  name: "UserInfoCard",
  mixins: [matchingColorMixins],
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    hideHomepage: Boolean,
    hideBorder: Boolean,
  },
};
</script>
